/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { useSwipeable } from 'react-swipeable';

import SideDrawer from '../sideDrawer/sideDrawer';
import ToolBar from '../navigation/toolBar/toolBar';
import BusinessDrawer from '../businessDrawer/index';
import { UserContext } from '../context/userContext';
import { useGlobalState } from '../context/qrState';
import LogOutDraw from '../logoutDraw/logoutDraw';
import SuccessLayout from './feedBackSuccess/feedbackSuccess';
import DownloadSuccessLayout from './downloadSuccessLayout/downloadSuccess';

interface Props {
  children: any;
}

const Layout: React.FC<Props> = ({ children }) => {
  const [loading, setLoading] = useGlobalState('loadingState');
  const [fetchingStatus, setFetchingStatus] = useGlobalState('dataFetch');
  const [pageNumber, setPageNumber] = useGlobalState('pageNumber');
  const [showSideDrawer, setShowSideDrawer] = useGlobalState('sideDrawState');
  const [showBusinessDrawer, setShowBusinessDrawer] = useState(false);
  const [showLogoutDraw, setShowLogoutDraw] = useState(false);
  // const [pan, setPan] = useState<any>();
  // const [buzDetails, setBuzDetails] = useState<any>();
  const {
    businessDetails,
    business,
    businessHierarchy,
    pageName,
    orgId,
    userEmail,
  } = useContext<Record<string, any>>(UserContext);
  const openBusinessDrawer = () => {
    setShowSideDrawer(false);
    setShowBusinessDrawer(true);
  };

  const openLogoutDraw = () => {
    setShowSideDrawer(false);
    setShowLogoutDraw(true);
  };
  useEffect(() => {
    if (showSideDrawer) {
      setLoading(false);
    }
  }, [showSideDrawer]);

  useEffect(() => {
    // getBusinessList().then((res) => {
    //   setPan(res?.panDb);
    //   setBuzDetails(res?.businessDataStore);

    // });
    business.getBusinessHierarchy();
  }, []);

  useEffect(() => {
    if (businessHierarchy && businessHierarchy.data.length !== 0) {
      let orgIdValue: string = businessHierarchy.data[0].id;
      if(localStorage.getItem('ORGID')){
        // @ts-ignore
        if( localStorage.getItem('ORGID') in businessHierarchy.businessDataStore ){
           // @ts-ignore
            orgIdValue = localStorage.getItem('ORGID');
        }
      }
      businessDetails.addOrgId(orgIdValue);
    }
  }, [businessHierarchy]);

  const getOrgId = async (id: any, level: any) => {
    if (id !== (orgId || localStorage.getItem('ORGID'))) {
      businessDetails.addOrgId(id);
      businessDetails.addBusinessLevel(level);
      setFetchingStatus('FETCHING_DATA');
      setPageNumber(0);
    }
  };
  const toolBarClicked = (value: string) => {
    if (
      window.location.pathname !== '/qr' &&
      window.location.pathname !== '/comingsoon'
    ) {
      setShowSideDrawer(!showSideDrawer);
    }
  };

  const handlers = useSwipeable({
    trackMouse: true,
    onSwipedRight: () => {
      if (!showSideDrawer && pageName === 'DEFAULT') {
        setShowSideDrawer(!showSideDrawer);
      }
    },
  });

  return (
    <>
      <ToolBar clicked={toolBarClicked} />
      <SideDrawer
        // showSideDrawer={showSideDrawer}
        closeSideDrawer={() => setShowSideDrawer(false)}
        openBusinessDrawer={openBusinessDrawer}
        openLogoutDraw={openLogoutDraw}
      />
      <main {...handlers}>{children}</main>
      {businessHierarchy &&
        businessHierarchy.panDb &&
        businessHierarchy.businessDataStore && (
          <>
            <BusinessDrawer
              showBusinessDrawer={showBusinessDrawer}
              closeBusinessDrawer={() => setShowBusinessDrawer(false)}
              panDb={businessHierarchy.panDb}
              businessDataStore={businessHierarchy.businessDataStore}
              selectOrg={getOrgId}
            />
          </>
        )}
      <LogOutDraw
        isOpen={showLogoutDraw}
        closeLogOutDrawer={() => setShowLogoutDraw(false)}
      />
      <SuccessLayout/>
      <DownloadSuccessLayout />
    </>
  );
};

export default Layout;
